// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from 'D:/gitspace/coffee-bean/safone-cb-web/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import LineChartOutlined from 'D:/gitspace/coffee-bean/safone-cb-web/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/LineChartOutlined';
export default { SmileOutlined, LineChartOutlined };
